import { MenuProps, styled, TextField, TextFieldProps, useTheme } from '@mui/material'
import { COLORS } from 'app-constants'
import { getElementColor } from 'utils/darkMode'

// Hack to workaround MUI Select not supporting html input placeholder property.
const SelectTextField = styled(TextField)`
  span.placeholder {
    opacity: 0.42;
    transition: opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  }
`

type Props = {
  isDarkBackdrop?: boolean
  renderValue?: (selected: any) => React.ReactNode
  onOpen?: (event: React.SyntheticEvent) => void
  onClose?: (event: React.SyntheticEvent) => void
  renderValueOnEmpty?: boolean
  menuProps?: Partial<MenuProps>
  id: string
}

const StyledSelectTextField = ({
  renderValue,
  onOpen,
  onClose,
  menuProps,
  renderValueOnEmpty,
  isDarkBackdrop,
  id,
  ...props
}: Props & TextFieldProps) => {
  const theme = useTheme()

  return (
    <SelectTextField
      InputLabelProps={{
        htmlFor: id,
      }}
      inputProps={{
        id,
      }}
      select
      SelectProps={{
        displayEmpty: true,
        MenuProps: {
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
          },
          sx: {
            marginLeft: '-8px',
          },
        },
        onOpen,
        onClose,
        renderValue: (selected) => {
          if (!selected && !renderValueOnEmpty) {
            return <span className="placeholder">{props.placeholder}</span>
          }

          if (renderValue) {
            return renderValue(selected)
          } else {
            return (
              <span
                style={{
                  color: COLORS.GRAY_0,
                }}>{`${selected}`}</span>
            )
          }
        },
      }}
      sx={{
        '& .MuiFormLabel-root': {
          color: getElementColor(isDarkBackdrop || false, theme),
        },
      }}
      {...props}
    />
  )
}

export default StyledSelectTextField
